"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../shared/services/restservice");
class AuthService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.getOauthTokenUrl = '/rest-api/token/v1/login-status/';
    }
    refreshToken() {
        return this.get(this.getOauthTokenUrl).pipe(operators_1.map((res) => {
            this.ouathTokenData = res;
            return res;
        }));
    }
    getToken() {
        if (this.ouathTokenData) {
            return 'Bearer ' + this.ouathTokenData.token;
        }
        return '';
    }
    getSession() {
        if (this.ouathTokenData) {
            return this.ouathTokenData.sessionId;
        }
        return '';
    }
}
exports.AuthService = AuthService;
//# sourceMappingURL=auth.service.js.map